(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/big/assets/javascripts/models/big-statistics-model_desktop.js') >= 0) return;  svs.modules.push('/components/statistics/big/assets/javascripts/models/big-statistics-model_desktop.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.big = svs.statistics.big || {};
  svs.statistics.big.models = svs.statistics.big.models || {};

  svs.statistics.big.models.BigStatisticsModel = Backbone.Model.extend({
    getMatchOnFetch: false,
    getAdditionalInfos: false,
    showFavStar: false,
    isSynced: false,
    CONSTANTS: {
      RESULTTYPE: {
        FULLTIME: 2,
        EXTRATIME0: 3,
        EXTRATIME1: 10,
        EXTRATIME2: 11,
        PENALTIES: 4,
        CURRENT: 9
      },
      MATCHSTATUS: {
        INPENALTIES: 22,
        ENDEDAFTERPENALTIES: 33
      },
      SPORT: {
        SOCCER: 1000002,
        TROTTING: 1000060
      }
    },
    url: function() {
      var matchId = this.get('match').matchId,
        returnUrl;

      if (matchId) {
        returnUrl =
          svs.core.jupiter.url() +
          '/multifetch?urls=/sport/1/matches/' +
          matchId +
          '/draws';

        if (this.get('showOdds')) {
          returnUrl += '|/sport/1/matches/' + matchId + '/odds';
        }

        if (this.getMatchOnFetch || this.getAdditionalInfos) {
          returnUrl +=
            '|/sport/1/matches/' +
            matchId +
            '?include=match.additionalInfos.description,match.additionalInfos.value';
        }
      }

      return returnUrl || '';
    },

    initialize: function() {
      var match = this.get('match');
      var hasMatch = match && match.matchId;
      var self = this;

      if (svs.utils.ns.isNamespace('league.sport', match)) {
        match.sport = match.league.sport;
      } else {
        match.sport = match.sport || {};
      }

      match.league = match.league || {};
      match.league.sport = match.league.sport
        ? match.league.sport
        : match.sport;

      this.set('hasMatch', hasMatch, { silent: true });

      if (!hasMatch) {
        if (this.get('matchId') !== 0) {
          this.set('match', { matchId: this.get('matchId') }, { silent: true });
          this.getMatchOnFetch = true;
        }
      } else {
        var isTennis =
          match.league.sport.id &&
          match.league.sport.id === svs.statistics.constants.TENNIS;
        if (typeof match.additionalInfos === 'undefined' && isTennis) {
          this.getAdditionalInfos = true;
        }
        this.enableDeepLinking();
      }

      this.listenTo(this, 'destroy', this.dispose);
      this.listenTo(this, 'change:match', this.matchChanged);
      this.listenTo(this, 'change:hasStarted', this.hasStartedChanged);

      if (match.matchId && match.matchId !== 0) {
        this.fetch({
          success: function() {
            self.matchChanged();
          },
          error: function() {
            self.matchChanged();
          }
        });
      }
    },
    enableDeepLinking: function() {
      if (this.get('enabledDeepLink') === false) {
        return;
      }

      var match = this.get('match'),
        isSelfService = svs.utils.ns.isNamespace(
          'svs.core.config.data.svsconfig.isSelfService'
        )
          ? svs.core.config.data.svsconfig.isSelfService
          : false;

      if (this.hasSport()) {
        var sportId = svs.utils.ns.isNamespace('league.sport', match)
          ? match.league.sport.id
          : match.sport.id;
        if (this.retrieveSportById(sportId)) {
          var deepLink = isSelfService
            ? false
            : sportId !== this.CONSTANTS.SPORT.TROTTING;
          this.set('enabledDeepLink', deepLink, { silent: true });
        }
      }
    },

    hasSport: function() {
      var match = this.get('match');
      return (
        _.isObject(match) &&
        _.isObject(match.league) &&
        (_.has(match.league, 'sport') || _.has(match, 'sport'))
      );
    },

    retrieveSportById: function(sportId) {
      return new svs.sport.themeLoader().retrieveSportById(sportId);
    },

    hasStartedChanged: function() {
      this.checkOdds(true);
      this.createInitObject();
    },

    parse: function(response) {
      var object = {};
      var match = this.get('match');
      if (match.matchId) {
        object.draws = this.parseDraws(response);
        object.odds = this.parseOdds(
          response.responses[1] ? response.responses[1] : {}
        );
        object.showPlayNow = this.shouldShowPlayNow(object.draws);
      }

      if (this.getMatchOnFetch || this.getAdditionalInfos) {
        match.additionalInfos = response.responses[2]
          ? response.responses[2].match.additionalInfos
          : match.additionalInfos;

        if (this.getMatchOnFetch) {
          this.matchChanged();
        }
      }

      if (!this.isSynced) {
        this.onSync();
        this.isSynced = true;
      }

      return object;
    },

    onSync: function() {
      this.checkOdds(true);
      this.createInitObject(); 
      this.matchChanged();
      this.startSockets();
    },

    getStatusId: function() {
      var match = this.get('match');

      if (_.isNumber(match.statusId)) {
        return match.statusId; 
      }
      return match.status; 
    },

    parseOdds: function(odds) {
      return odds;
    },

    parseDraws: function(response) {
      return response.responses[0].drawInfo || {};
    },
    checkOdds: function(silent) {
      var odds = this.get('odds') || {};

      odds.hasOdds = !_.isUndefined(odds.oddsInfo);

      odds.showOdds =
        !this.isEnded() &&
        !this.isFullTimeOrPassed(this.getStatusId()) &&
        odds.hasOdds;
      odds.showRegularOdds =
        odds.hasOdds &&
        !odds.oddsInfo.showLiveOdds &&
        !this.get('hasStarted') &&
        !_.isUndefined(odds.oddsInfo.odds) &&
        odds.oddsInfo.odds !== null;

      this.set('odds', odds, { silent: silent });

      if (!silent) {
        this.trigger('change', this);
      }
    },
    shouldShowPlayNow: function(draws) {
      return (
        !_.isUndefined(draws.oddsetDraws) &&
        draws.oddsetDraws.drawState === 'Open' &&
        draws.oddsetDraws.eventCount > 0 &&
        this.get('showPlayNow')
      );
    },
    isEnded: function() {
      return this.loadTheme(
        'isEnded',
        this.get('match').statusId || this.get('match').status
      );
    },

    isFullTimeOrPassed: function(status, options) {
      return this.loadTheme('isFullTimeOrPassed', status, options);
    },

    isLive: function() {
      return this.loadTheme(
        'isLive',
        this.get('match').statusId || this.get('match').status
      );
    },
    setParticipants: function() {
      var match = this.get('match');
      var isParticipants =
        !_.isUndefined(match.participants) && match.participants.length > 0;
      var participants = [];
      if (isParticipants || match.homeTeam) {
        participants = [
          {
            name: isParticipants
              ? match.participants[0].name
              : match.homeTeam.name,
            mediumName: isParticipants
              ? match.participants[0].mediumName
              : match.homeTeam.mediumName,
            id: isParticipants ? match.participants[0].id : match.homeTeam.id,
            type: 'home'
          },
          {
            name: isParticipants
              ? match.participants[1].name
              : match.awayTeam.name,
            mediumName: isParticipants
              ? match.participants[1].mediumName
              : match.awayTeam.mediumName,
            id: isParticipants ? match.participants[1].id : match.awayTeam.id,
            type: 'away'
          }
        ];
        this.set('participants', participants, { silent: true });
      }
    },

    setPeriodResult: function() {
      var result = this.get('periodResultText');

      if (_.isUndefined(result)) {
        result = this.loadTheme('getThemedExtraResult', this.get('match'));
        this.set('periodResult', result, { silent: true });
      }
    },

    createInitObject: function() {
      var match = this.get('match');
      var hasOddsetDraws =
          !_.isUndefined(this.get('draws')) &&
          !_.isUndefined(this.get('draws').oddsetDraws),
        matchStart = false,
        date = true,
        sportId = svs.utils.ns.isNamespace('league.sport', match)
          ? match.league.sport.id
          : undefined,
        isLive = svs.sport.matchInitBox.isDrawLive(
          this.get('match'),
          this.get('regCloseTime')
        );
      if (!sportId) {
        sportId = svs.utils.ns.isNamespace('sport.id', match)
          ? match.sport.id
          : 0;
      }

      if ((!this.isEnded() && !!match.matchStart) || !!match.startTime) {
        matchStart = match.matchStart || match.startTime;
      }
      if (this.isEnded() || this.isLive() || !matchStart) {
        date = false;
      }

      this.set(
        'initObject',
        {
          opt: {
            tv:
              !_.isUndefined(match.media) &&
              match.media !== null &&
              match.media.length > 0 &&
              !this.isEnded(),
            spelstopp: this.isShowRegCloseTime()
              ? this.get('regCloseTime')
              : false,
            date: date
          },
          sport: sportId,
          error: false, 
          startTime: matchStart,
          status: {
            id: match.statusId || match.status,
            realTime: match.statusTime,
            text: this.get('matchInitText')
          },
          matchId: match.matchId,
          showStartText: this.get('showStartText')
        },
        { silent: true }
      );
      if (
        hasOddsetDraws &&
        this.get('draws').oddsetDraws.isLiveDraw &&
        isLive
      ) {
        this.get('initObject').opt.startedLiveDraw = true;
      }
      if (
        this.get('isLive') ||
        (hasOddsetDraws &&
          (this.get('draws').oddsetDraws.hasLiveDraw ||
            this.get('draws').oddsetDraws.isLiveDraw))
      ) {
        this.get('initObject').opt.live = true;
      }
    },

    startSockets: function() {
      if (this.get('match').matchId) {
        if (this.get('updateOdds')) {
          svs.core.socket.subscribe(
            '/sport/1/matches/' + this.get('match').matchId + '/odds',
            this.oddsChange,
            this,
            false
          );
        }
        if (this.get('updateResult')) {
          svs.core.socket.subscribe(
            '/sport/1/matches/' + this.get('match').matchId + '/matchlist',
            this.resultChange,
            this,
            false
          );
        }
      }
    },

    isShowRegCloseTime: function() {
      var now = moment(),
        regCloseTime = this.get('regCloseTime');

      if (!regCloseTime) {
        return false;
      }

      regCloseTime = moment(regCloseTime);

      return now.isBefore(regCloseTime);
    },

    matchChanged: function() {
      this.setParticipants();
      this.setPeriodResult();
      this.createInitObject();

      var match = this.get('match');

      if (!svs.utils.ns.isNamespace('league.sport', match)) {
        if (match && match.sport) {
          match.league = match.league || {};
          match.league.sport = match.sport;
        } else {
          match.league = {};
          match.league.sport = {};
        }
      }

      var hasStarted =
        this.loadTheme('hasStarted', match.statusId || match.status) ||
        (!_.isUndefined(this.get('homeScore')) && this.get('homeScore') > 0) ||
        (!_.isUndefined(this.get('awayScore')) && this.get('awayScore') > 0);

      if (
        this.get('updateResult') &&
        hasStarted &&
        !_.isUndefined(match.homeTeam) &&
        !_.isUndefined(match.awayTeam)
      ) {
        var searchMatchResult = svs.utils.result.getResult(match);

        this.set(
          {
            homeScore: searchMatchResult
              ? searchMatchResult.home
              : match.homeTeam.result,
            awayScore: searchMatchResult
              ? searchMatchResult.away
              : match.awayTeam.result
          },
          { silent: true }
        );
      }

      this.set(
        {
          hasStarted: hasStarted,
          hasSportNameAndLeague:
            !_.isUndefined(match.league) &&
            !_.isUndefined(match.league.name) &&
            !_.isUndefined(match.league.sport) &&
            !_.isUndefined(match.league.sport.name)
        },
        { silent: true }
      );

      this.checkOdds(true);
      this.checkForOvertimeResult();
      this.trigger('change', this);
    },

    oddsChange: function(result) {
      if (result !== '') {
        this.set('odds', this.parseOdds(result), { silent: true });

        if (
          !_.isUndefined(this.get('draws')) &&
          !_.isUndefined(this.get('draws').oddsetDraws) &&
          !_.isUndefined(this.get('odds')) &&
          !_.isUndefined(this.get('odds').oddsInfo)
        ) {
          this.get('draws').oddsetDraws.isLiveDraw = this.get(
            'odds'
          ).oddsInfo.showLiveOdds;
          this.createInitObject();
        }

        this.checkOdds(false);
      }
    },

    checkForOvertimeResult: function() {
      var self = this,
        match = this.get('match'),
        results = match.result,
        fullTime = _.find(results, function(result) {
          return result.type === self.CONSTANTS.RESULTTYPE.FULLTIME;
        }),
        current = _.find(results, function(result) {
          return result.type === self.CONSTANTS.RESULTTYPE.CURRENT;
        });

      if (fullTime !== undefined) {
        if (
          current !== undefined &&
          (current.home > fullTime.home || current.away > fullTime.away)
        ) {
          self.set('fullTimeScore', fullTime.home + ' - ' + fullTime.away, {
            silent: true
          });
        }
      }
      var isInShootout =
        this.getStatusId() === this.CONSTANTS.MATCHSTATUS.INPENALTIES ||
        this.getStatusId() === this.CONSTANTS.MATCHSTATUS.ENDEDAFTERPENALTIES;

      if (
        isInShootout &&
        match.league.sport.id === this.CONSTANTS.SPORT.SOCCER
      ) {
        this.checkForPenaltiesResult();
        var extra2, extra1, extra0;

        extra2 = _.find(results, function(result) {
          return result.type === self.CONSTANTS.RESULTTYPE.EXTRATIME2;
        });
        if (!extra2) {
          extra1 = _.find(results, function(result) {
            return result.type === self.CONSTANTS.RESULTTYPE.EXTRATIME1;
          });
          if (!extra1) {
            extra0 = _.find(results, function(result) {
              return result.type === self.CONSTANTS.RESULTTYPE.EXTRATIME0;
            });
          }
        }
        current = extra2 || extra1 || extra0 || fullTime;

        var searchMatchResult = svs.utils.result.getResult(match);

        this.set(
          {
            homeScore: searchMatchResult
              ? searchMatchResult.home
              : current.home,
            awayScore: searchMatchResult ? searchMatchResult.away : current.away
          },
          { silent: true }
        );
      }
    },

    checkForPenaltiesResult: function() {
      var self = this;
      var results = this.get('match').result;
      var penalties = _.find(results, function(result) {
        return result.type === self.CONSTANTS.RESULTTYPE.PENALTIES;
      });

      if (penalties) {
        self.set('penaltiesScore', penalties.home + ' - ' + penalties.away, {
          silent: true
        });
      }
    },
    resultChange: function(result) {
      if (result !== '') {
        if (this.get('updateResult')) {
          var searchMatchResult = svs.utils.result.getResult(this.get('match'));
          this.set(
            {
              homeScore: searchMatchResult
                ? searchMatchResult.home
                : result.match.homeTeam.result,
              awayScore: searchMatchResult
                ? searchMatchResult.away
                : result.match.awayTeam.result
            },
            { silent: true }
          );
        }

        this.set('match', result.match, { silent: true });
        this.matchChanged();
      }
    },

    loadTheme: function(functionName, param) {
      var returner = '';
      var sportId = 0;
      var match = this.get('match');

      if (svs.utils.ns.isNamespace('league.sport', match)) {
        sportId = match.league.sport.id;
      } else if (match && match.sport) {
        sportId = match.sport.id;
      }

      if (sportId > 0) {
        var theme = new svs.sport.themeLoader({
          sport: sportId
        });
        theme.load(function(template, init) {
          if (init) {
            returner = init(functionName, param);
          }
        }, 'init');
      }
      return returner;
    },

    dispose: function() {
      if (this.get('updateResult')) {
        svs.core.socket.unsubscribe(
          '/sport/1/matches/' + this.get('match').matchId + '/matchlist',
          this.resultChange
        );
      }
      if (this.get('updateOdds')) {
        svs.core.socket.unsubscribe(
          '/sport/1/matches/' + this.get('match').matchId + '/odds',
          this.oddsChange
        );
      }
    },

    defaults: function() {
      return {
        matchId: 0,
        showPlayNow: true,
        showBackButton: false,
        showRegCloseTime: true,
        showTopNav: false,
        showCloseButton: true,
        hasStarted: false,
        draw: {},
        showStartText: false,
        isSportservice: svs.core.data.baseUrl.indexOf('sportservice') > -1
      };
    }
  });
})(Backbone, _, svs);

 })(window);